import "./bootstrap";
import "../css/app.css";
import "./i18n";

import { createRoot } from "react-dom/client";
import { createInertiaApp, router } from "@inertiajs/react";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ThemeProvider } from "./Components/providers/ThemeProvider";
import LanguageProvider from "./Components/providers/LanguageProvider";
import { Toaster } from "./Components/ui/Sonner";
import CopyRight from "./Components/CopyRight";
import { toast } from "sonner";
import { t } from "i18next";

const appName = import.meta.env.VITE_APP_NAME || "مهندس القيم";

// Surface non-Inertia error responses (e.g. 403/500) and network errors as a
// toast instead of a silent full-screen modal, so failed actions are visible.
// Map the HTTP status to a descriptive message so it's not just a generic error.
function messageForStatus(status?: number): string {
  if (status === 403) return t("app.errorForbidden");
  if (status === 419) return t("app.errorSession");
  if (status && status >= 500) return t("app.errorServer");
  return t("app.error");
}

router.on("invalid", (event) => {
  const status = (event.detail?.response as { status?: number } | undefined)
    ?.status;
  toast.error(messageForStatus(status));
  if (import.meta.env.PROD) {
    event.preventDefault();
  }
});
router.on("exception", () => {
  toast.error(t("app.error"));
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.tsx`,
            import.meta.glob("./Pages/**/*.tsx")
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);
        const locale = props.initialPage.props.locale as string;
        root.render(
            <LanguageProvider locale={props.initialPage.props.locale as string}>
                <ThemeProvider
                    defaultTheme="light"
                    storageKey="vite-ui-theme"
                    locale={locale}
                >
                    <App {...props} />
                    <Toaster dir={locale === "ar" ? "rtl" : "ltr"} />
                </ThemeProvider>
            </LanguageProvider>
        );
    },
    progress: {
        color: "#d60a53",
    },
});
